import Layout from '@/layout/index.vue';

export default [
  {
    path: '/platformManage',
    redirect: '/platformManage/formal/slaInfo',
  },
  {
    path: '/platformManage/formal',
    component: Layout,
    name: 'basicInfo',
    meta: {
      title: '基础信息',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'slaInfo',
        name: 'slaInformation',
        component: () => import('@/views/platformManage/baseInfo/slaInfo.vue'),
        meta: { title: 'SLA信息', icon: 'el-icon-s-management' },
      },
      {
        path: 'resourceInfo',
        name: 'resourceInformation',
        component: () => import('@/views/platformManage/resource/index.vue'),
        meta: { title: '资源信息', icon: 'el-icon-s-management' },
      },
      {
        path: 'staffInfo',
        name: 'staffInformation',
        component: () => import('@/views/platformManage/staff/index.vue'),
        meta: { title: '员工信息', icon: 'el-icon-s-management' },
      },
    ],
  },

  {
    path: '/configManage/formal',
    component: Layout,
    name: 'ConfigManage',
    meta: {
      title: '配置管理',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'config',
        name: 'orderConfig',
        component: () => import('@/views/configManage/orderType/index.vue'),
        meta: { title: '工单类型', icon: 'el-icon-s-management' },
      },
      {
        path: 'picaSLA',
        name: 'picaSLA',
        component: () => import('@/views/configManage/picaSLA/index.vue'),
        meta: { title: '派单SLA', icon: 'el-icon-s-management' },
      },
      {
        path: 'autoDispatchSet',
        name: 'autoDispatchSet',
        component: () => import('@/views/configManage/autoDispatchSet/index.vue'),
        meta: { title: '自动派单设置', icon: 'el-icon-s-management' },
      },
    ],
  },
  {
    path: '/serverCenter/formal',
    component: Layout,
    name: 'serviceCenter',
    meta: {
      title: '服务中心',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/views/serviceCenter/feedback.vue'),
        meta: { title: '意见反馈', icon: 'el-icon-s-management' },
      },
      {
        path: 'referral',
        name: 'referral',
        component: () => import('@/views/serviceCenter/referral.vue'),
        meta: { title: '平台介绍', icon: 'el-icon-s-management' },
      },
      {
        path: 'viceService',
        name: 'viceService',
        component: () => import('@/views/serviceCenter/viceService.vue'),
        meta: { title: '语音服务', icon: 'el-icon-s-management' },
      },
      {
        path: 'logQuery',
        name: 'logQuery',
        component: () => import('@/views/serviceCenter/logQuery.vue'),
        meta: { title: '日志查询', icon: 'el-icon-s-management' },
      },
      {
        path: 'http://192.168.1.253/',
        name: 'alitaOmniGate',
        meta: { title: 'Alita OmniGate', icon: 'el-icon-link' },
      },
    ],
  },
];
